<div [ngClass]="{'loading':true,'hidespinner':!show,'showspinnner':show}">
    <div class="d-flex justify-content-center spinner">
        <div class="spinner-grow text-primary" role="status" style="width: 8rem; height: 8rem;">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>